import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Modal, ModalBody, ModalFooter, Row } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import Swal from 'sweetalert2';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ClientOnExcursionService from '../../../../repository/clientOnExcursionRepository/ClientOnExcursionRepository';
import PaymentHistoryService from '../../../../repository/paymentHistoryRepository/PaymentHistoryRepository';
import { ReactComponent as EditPen } from '../../../../assets/icons/EditPen.svg';
import { ReactComponent as DeleteX } from '../../../../assets/icons/DeleteX.svg';
import { ReactComponent as X } from '../../../../assets/icons/X.svg';
import { ReactComponent as Check } from '../../../../assets/icons/Check.svg';
import { strings } from '../../../../localization/Localization';

const ClientPaymentHistoryModal = ({
  showModal,
  handleClose,
  selectedExcursionHistory,
  onDataUpdate,
  fetchClientForPointsUpdate
}) => {
  const [excursionHistory, setExcursionHistory] = useState(null);
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [editedPayment, setEditedPayment] = useState({
    id: null,
    date: null,
    sum: ''
  });
  const [isDetailsEditing, setIsDetailsEditing] = useState(false);
  const [editedDetails, setEditedDetails] = useState({
    startingPoint: '',
    travelingDocument: '',
    note: '',
    seatNumber: '',
    discount: '',
    extraExpenses: '',
    // pointsUsed: '',
    confirmedReservation: false
  });

  const schema = yup.object().shape({
    date: yup.date().required(strings.requiredField),
    sum: yup.number()
      .required(strings.requiredField)
      .positive(strings.requiredField)
      .max(1000000,)
  });

  useEffect(() => {
    if (selectedExcursionHistory?.id) {
      clientOnExcursionHistory(selectedExcursionHistory.id);
      fetchPaymentHistory(selectedExcursionHistory.id);
    }
  }, [selectedExcursionHistory]);

  const clientOnExcursionHistory = (id) => {
    ClientOnExcursionService.getClientOnExcursionById(id)
      .then((response) => {
        setExcursionHistory(response.data);
      })
      .catch((error) => {
        console.error('Error fetching client on excursion data:', error);
      });
  };

  const fetchPaymentHistory = (id) => {
    PaymentHistoryService.getPaymentsByClientOnExcursionId(id)
      .then((response) => {
        setPaymentHistory(response.data);
      })
      .catch((error) => {
        console.error('Error fetching payment history:', error);
      });
  };

  const errorAlert = () => {
    Swal.fire({
      title: strings.somethingWentWrong,
      icon: 'error',
      dangerMode: true
    });
  };

  useEffect(() => {
    if (excursionHistory) {
      setEditedDetails({
        startingPoint: excursionHistory.startingPoint || '',
        travelingDocument: excursionHistory.travelingDocument || '',
        note: excursionHistory.note || '',
        seatNumber: excursionHistory.seatNumber || '',
        discount: excursionHistory.discount || 0,
        extraExpenses: excursionHistory.extraExpenses || 0,
        // pointsUsed: excursionHistory.pointsUsed || 0,
        confirmedReservation: excursionHistory.confirmedReservation || false
      });
    }
  }, [excursionHistory]);

  const handleDetailsEditClick = () => {
    setIsDetailsEditing(true);
  };

  const handleDetailsCancel = () => {
    setIsDetailsEditing(false);
    if (excursionHistory) {
      setEditedDetails({
        startingPoint: excursionHistory.startingPoint || '',
        travelingDocument: excursionHistory.travelingDocument || '',
        note: excursionHistory.note || '',
        seatNumber: excursionHistory.seatNumber || '',
        discount: excursionHistory.discount || 0,
        extraExpenses: excursionHistory.extraExpenses || 0,
        // pointsUsed: excursionHistory.pointsUsed || 0,
        confirmedReservation: excursionHistory.confirmedReservation || false
      });
    }
  };

  const handleDetailsChange = (e) => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setEditedDetails({
      ...editedDetails,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleDetailsSubmit = async () => {
    try {
      const detailsData = {
        discount: editedDetails.discount,
        // pointsUsed: editedDetails.pointsUsed,
        extraExpenses: editedDetails.extraExpenses,
        startingPoint: editedDetails.startingPoint,
        travelingDocument: editedDetails.travelingDocument,
        note: editedDetails.note,
        seatNumber: editedDetails.seatNumber,
        confirmedReservation: editedDetails.confirmedReservation
      };

      await ClientOnExcursionService.updateClientOnExcursionPaymentDetails(
        selectedExcursionHistory.id,
        detailsData.discount,
        // detailsData.pointsUsed,
        detailsData.extraExpenses,
        detailsData.startingPoint,
        detailsData.travelingDocument,
        detailsData.note,
        detailsData.seatNumber,
        detailsData.confirmedReservation
      );

      clientOnExcursionHistory(selectedExcursionHistory.id);
      setIsDetailsEditing(false);

      if (onDataUpdate) {
        onDataUpdate();
      }
      // if (fetchClientForPointsUpdate) {
      //   fetchClientForPointsUpdate(selectedExcursionHistory.client.id);
      // }

      Swal.fire({
        icon: 'success',
        title: strings.successfullyUpdatedDetails,
      });
    } catch (error) {
      console.error('Error updating details:', error);
      errorAlert();
    }
  };

  function formatDateToDDMMYYYY (dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${day}/${month}/${year}`;
  }

  const handleEditClick = (index, payment) => {
    setEditIndex(index);
    setEditedPayment({
      id: payment.id,
      date: new Date(payment.date.split('/').reverse().join('-')),
      sum: payment.sum
    });
  };

  const handleEditSubmit = async () => {
    try {
      // const originalPayment = paymentHistory[editIndex];
      const paymentData = {
        id: editedPayment.id,
        date: formatDateToDDMMYYYY(editedPayment.date),
        sum: editedPayment.sum
      };
      await PaymentHistoryService.updatePayment(editedPayment.id, paymentData);
      await fetchPaymentHistory(selectedExcursionHistory.id);
      await clientOnExcursionHistory(selectedExcursionHistory.id);

      setEditIndex(null);

      if (onDataUpdate) {
        await onDataUpdate();
      }

      try {
        if (fetchClientForPointsUpdate && selectedExcursionHistory.client && selectedExcursionHistory.client.id) {
          await fetchClientForPointsUpdate(selectedExcursionHistory.client.id);
        }
      } catch (pointsError) {
        console.error('Error updating points:', pointsError);
      }

      Swal.fire({
        icon: 'success',
        title: strings.successfullyUpdatedPayment,
      });
    } catch (error) {
      console.error('Error updating payment:', error);
      errorAlert();
    }
  };

  const handleDelete = (paymentId) => {
    Swal.fire({
      title: strings.confirmationDelete,
      icon: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      dangerMode: true,
    }).then((result) => {
      if (result.isConfirmed) {
        PaymentHistoryService.deletePayment(paymentId)
          .then(() => {
            Swal.fire({
              icon: 'success',
              title: strings.paymentDeletedSuccessfully,
            });
            fetchPaymentHistory(selectedExcursionHistory.id);
            clientOnExcursionHistory(selectedExcursionHistory.id);

            if (onDataUpdate) {
              onDataUpdate();
            }

            try {
              if (fetchClientForPointsUpdate && selectedExcursionHistory.client && selectedExcursionHistory.client.id) {
                fetchClientForPointsUpdate(selectedExcursionHistory.client.id);
              }
            } catch (pointsError) {
              console.error('Error updating points:', pointsError);
            }
          })
          .catch((error) => {
            console.error('Error deleting payment:', error);
            errorAlert();
          });
      }
    });
  };

  const addPaymentSuccessfulAlert = () => {
    Swal.fire({
      icon: 'success',
      title: strings.successfullyAddedPayment,
    });
  };

  const onFormSubmit = (values, { resetForm }) => {
    const paymentData = {
      date: formatDateToDDMMYYYY(values.date),
      sum: values.sum,
      clientOnExcursion: { id: selectedExcursionHistory.id }
    };

    PaymentHistoryService.addPayment(paymentData)
      .then(() => {
        addPaymentSuccessfulAlert();
        fetchPaymentHistory(selectedExcursionHistory.id);
        clientOnExcursionHistory(selectedExcursionHistory.id);
        resetForm();
        if (onDataUpdate) {
          onDataUpdate();
        }

        try {
          if (fetchClientForPointsUpdate && selectedExcursionHistory.client && selectedExcursionHistory.client.id) {
            fetchClientForPointsUpdate(selectedExcursionHistory.client.id);
          }
        } catch (pointsError) {
          console.error('Error updating points:', pointsError);
        }
      })
      .catch((error) => {
        console.error('Error adding payment:', error);
        errorAlert();
      });
  };

  const calculateTotalPaid = () => {
    return paymentHistory.reduce((total, payment) => total + Number(payment.sum), 0);
  };

  const fields = [
    {
      name: 'date',
      label: strings.paymentDate,
      type: 'date',
      placeholder: strings.selectDate
    },
    {
      name: 'sum',
      label: strings.amount,
      type: 'number',
      placeholder: strings.enterAmount
    }
  ];

  const renderFields = (fields, values, handleChange, errors, touched) =>
    fields.map(({
      name,
      label,
      type,
      placeholder
    }) => {
      if (name === 'date') {
        return (
          <Form.Group as={Col} md='6' controlId={`validationFormik_${name}`} key={name}>
            <Form.Label>{label}</Form.Label>
            <ReactDatePicker
              selected={values[name] ? new Date(values[name]) : null}
              onChange={(date) => handleChange({
                target: {
                  name,
                  value: date
                }
              })}
              dateFormat='dd/MM/yyyy'
              className={`form-control ${touched[name] && errors[name] ? 'is-invalid' : ''}`}
              wrapperClassName='w-100'
              placeholderText={placeholder}
            />
            <Form.Control.Feedback type='invalid'>{errors[name]}</Form.Control.Feedback>
          </Form.Group>
        );
      }
      return (
        <Form.Group as={Col} md='6' controlId={`validationFormik_${name}`} key={name}>
          <Form.Label>{label}</Form.Label>
          <Form.Control
            type={type}
            name={name}
            value={values[name]}
            onChange={handleChange}
            isValid={touched[name] && !errors[name]}
            isInvalid={touched[name] && !!errors[name]}
            placeholder={placeholder}
          />
          <Form.Control.Feedback type='invalid'>{errors[name]}</Form.Control.Feedback>
        </Form.Group>
      );
    });

  return (
    <Modal show={showModal} onHide={handleClose} size='lg' centered>
      <Modal.Header closeButton>
        <Modal.Title>{strings.paymentHistory}</Modal.Title>
      </Modal.Header>
      <div className='modal-body'>
        <div className='row'>
          <div className='col-4'>
            <div className='client-details mb-4'>
              {excursionHistory && (
                <>
                  <div className='d-flex justify-content-between'>
                    <h5>{strings.details}</h5>
                    {!isDetailsEditing ? (
                      <Button
                        variant='link'
                        className='p-0'
                        onClick={handleDetailsEditClick}
                      >
                        <EditPen width='20px' height='20px'/>
                      </Button>
                    ) : (
                      <div>
                        <Button variant='primary' size='sm' className='me-2' onClick={handleDetailsSubmit}>
                          {strings.submit}
                        </Button>
                        <Button variant='secondary' size='sm' onClick={handleDetailsCancel}>
                          {strings.cancel}
                        </Button>
                      </div>
                    )}
                  </div>
                  <hr className='my-1'/>

                  {/* Non-editable fields */}
                  <div className='d-flex mb-2'>
                    <label className='fw-bold me-2'>{strings.clients}:</label>
                    <p className='mb-0'>{excursionHistory.client?.name ??
                      <i className='text-secondary'>{strings.noData}</i>}</p>
                  </div>

                  <div className='d-flex mb-2'>
                    <label className='fw-bold me-2'>{strings.excursion}:</label>
                    <p className='mb-0'>{excursionHistory.excursion?.name ??
                      <i className='text-secondary'>{strings.noData}</i>}</p>
                  </div>

                  <div className='d-flex mb-2'>
                    <label className='fw-bold me-2'>{strings.startingPoint}:</label>
                    {isDetailsEditing ? (
                      <Form.Control
                        type='text'
                        name='startingPoint'
                        value={editedDetails.startingPoint}
                        onChange={handleDetailsChange}
                        size='sm'
                      />
                    ) : (
                      <p className='mb-0'>{excursionHistory.startingPoint ??
                        <i className='text-secondary'>{strings.noData}</i>}</p>
                    )}
                  </div>

                  <div className='d-flex mb-2'>
                    <label className='fw-bold me-2'>{strings.travelingDocument}:</label>
                    {isDetailsEditing ? (
                      <Form.Control
                        type='text'
                        name='travelingDocument'
                        value={editedDetails.travelingDocument}
                        onChange={handleDetailsChange}
                        size='sm'
                      />
                    ) : (
                      <p className='mb-0'>{excursionHistory.travelingDocument ??
                        <i className='text-secondary'>{strings.noData}</i>}</p>
                    )}
                  </div>

                  <div className='d-flex mb-2'>
                    <label className='fw-bold me-2'>{strings.note}:</label>
                    {isDetailsEditing ? (
                      <Form.Control
                        type='text'
                        name='note'
                        value={editedDetails.note}
                        onChange={handleDetailsChange}
                        size='sm'
                      />
                    ) : (
                      <p className='mb-0'>{excursionHistory.note ??
                        <i className='text-secondary'>{strings.noData}</i>}</p>
                    )}
                  </div>
                  <div className='d-flex mb-2'>
                    <label className='fw-bold me-2'>{strings.seatNumber}:</label>
                    {isDetailsEditing ? (
                      <Form.Control
                        type='text'
                        name='seatNumber'
                        value={editedDetails.seatNumber}
                        onChange={handleDetailsChange}
                        size='sm'
                      />
                    ) : (
                      <p className='mb-0'>{excursionHistory.seatNumber ??
                        <i className='text-secondary'>{strings.noData}</i>}</p>
                    )}
                  </div>

                  <div className='d-flex mb-2'>
                    <label className='fw-bold me-2'>{strings.excursionDiscount}:</label>
                    <p className='mb-0'>{excursionHistory.excursion?.discount ??
                      <i className='text-secondary'>{strings.noData}</i>}</p>
                  </div>

                  <div className='d-flex mb-2'>
                    <label className='fw-bold me-2'>{strings.confirmedReservation}:</label>
                    {isDetailsEditing ? (
                      <Form.Check
                        type='checkbox'
                        name='confirmedReservation'
                        checked={editedDetails.confirmedReservation}
                        onChange={handleDetailsChange}
                      />
                    ) : (
                      excursionHistory.confirmedReservation ? (
                        <span className='text-success'>
              <Check width='18px' height='18px'/>
            </span>
                      ) : (
                        <span className='text-danger'>
              <X width='16px' height='16px'/>
            </span>
                      )
                    )}
                  </div>

                  <div className='d-flex mb-2'>
                    <label className='fw-bold me-2'>{strings.additionalDiscount}:</label>
                    {isDetailsEditing ? (
                      <Form.Control
                        type='number'
                        name='discount'
                        value={editedDetails.discount}
                        onChange={handleDetailsChange}
                        size='sm'
                      />
                    ) : (
                      <p className='mb-0'>{excursionHistory.discount ?? 0}</p>
                    )}
                  </div>

                  <div className='d-flex mb-2'>
                    <label className='fw-bold me-2'>{strings.extraExpenses}:</label>
                    {isDetailsEditing ? (
                      <Form.Control
                        type='number'
                        name='extraExpenses'
                        value={editedDetails.extraExpenses}
                        onChange={handleDetailsChange}
                        size='sm'
                      />
                    ) : (
                      <p className='mb-0'>{excursionHistory.extraExpenses ?? 0}</p>
                    )}
                  </div>

                  <div className='d-flex mb-2'>
                    <label className='fw-bold me-2'>{strings.pointsGained}:</label>
                    <p className='mb-0'>{excursionHistory.pointsGained ?? 0}</p>
                  </div>

                  <div className='d-flex mb-2'>
                    <label className='fw-bold me-2'>{strings.pointsUsed}:</label>
                    {/* {isDetailsEditing ? ( */}
                    {/*   <Form.Control */}
                    {/*     type='number' */}
                    {/*     name='pointsUsed' */}
                    {/*     value={editedDetails.pointsUsed} */}
                    {/*     onChange={handleDetailsChange} */}
                    {/*     size='sm' */}
                    {/*   /> */}
                    {/* ) : ( */}
                    <p className='mb-0'>{excursionHistory.pointsUsed ?? 0}</p>
                    {/* )} */}
                  </div>

                  <div className='d-flex mb-2'>
                    <label className='fw-bold me-2'>{strings.finalPrice}:</label>
                    <p className='mb-0'>{excursionHistory.finalPrice ?? 0}</p>
                  </div>

                  <div className='d-flex mb-2'>
                    <label className='fw-bold me-2'>{strings.paidPrice}:</label>
                    <p className='mb-0'>{excursionHistory.paidPrice ?? 0}</p>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className='col-8'>
            <h5>{strings.addPayment}</h5>
            <hr className='my-1'/>
            <Formik
              validationSchema={schema}
              onSubmit={onFormSubmit}
              initialValues={{
                date: new Date(),
                sum: ''
              }}
            >
              {({
                handleSubmit,
                handleChange,
                values,
                touched,
                errors
              }) => (
                <Form noValidate onSubmit={handleSubmit}>
                  <ModalBody>
                    <Row className='mb-3'>
                      {renderFields(fields, values, handleChange, errors, touched)}
                    </Row>
                  </ModalBody>
                  <ModalFooter>
                    <button type='submit' className='btn btn-primary'>{strings.submit}</button>
                  </ModalFooter>
                </Form>
              )}
            </Formik>

            <h5>{strings.paymentHistory}</h5>
            <hr className='my-1'/>
            {paymentHistory.length > 0 ? (
              <div style={{
                maxHeight: '200px',
                overflowY: 'auto'
              }}>
                <table className='table table-striped'>
                  <thead className={"table-header-css sticky-top"}>
                  <tr>
                    <th>{strings.paymentDate}</th>
                    <th>{strings.amount}</th>
                    <th>{strings.actions}</th>
                  </tr>
                  </thead>
                  <tbody>
                  {paymentHistory.map((payment, index) => (
                    <tr key={payment.id}>
                      <td>
                        {editIndex === index ? (
                          <ReactDatePicker
                            selected={editedPayment.date}
                            onChange={(date) => setEditedPayment({
                              ...editedPayment,
                              date
                            })}
                            dateFormat='dd/MM/yyyy'
                            className='form-control'
                            wrapperClassName='w-100'
                          />
                        ) : (
                          payment.date
                        )}
                      </td>
                      <td>
                        {editIndex === index ? (
                          <Form.Control
                            type='number'
                            value={editedPayment.sum}
                            onChange={(e) => setEditedPayment({
                              ...editedPayment,
                              sum: e.target.value
                            })}
                          />
                        ) : (
                          payment.sum
                        )}
                      </td>
                      <td>
                        <div className='d-flex justify-content-center'>
                          {editIndex === index ? (
                            <>
                              <Button variant='primary' size='sm' className='me-2' onClick={handleEditSubmit}>
                                {strings.submit}
                              </Button>
                              <Button variant='secondary' size='sm' onClick={() => setEditIndex(null)}>
                                {strings.cancel}
                              </Button>
                            </>
                          ) : (
                            <>
                              <Button
                                variant='link'
                                className='p-0 me-2'
                                onClick={() => handleEditClick(index, payment)}
                              >
                                <EditPen width='25px' height='25px'/> </Button>
                              <Button
                                variant='link'
                                className='p-0 text-danger'
                                onClick={() => handleDelete(payment.id)}
                              >
                                <DeleteX width='25px' height='25px'/>
                              </Button>
                            </>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                  </tbody>
                  <tfoot>
                  <tr>
                    <td className='fw-bold text-end'>{strings.paidPrice}:</td>
                    <td className='fw-bold'>{calculateTotalPaid()}</td>
                    <td></td>
                  </tr>
                  </tfoot>
                </table>
              </div>
            ) : (
              <p className='text-secondary'>{strings.noPaymentHistory}</p>
            )}
          </div>

        </div>
      </div>
    </Modal>
  );
};

export default ClientPaymentHistoryModal;